import type React from 'react';

import { AddToCartButton } from '../../../../../common/components/AddToCartButton';
import { useIsMobile } from '../../../../../common/components/atoms/ResponsiveBreakpoints';

const ProductDetailsAddToCartButton = (
    props: Omit<React.ComponentProps<typeof AddToCartButton>, 'fullWidth'>,
) => {
    const isMobile = useIsMobile();

    return (
        <AddToCartButton
            quantity={props.quantity}
            size={48}
            withButton
            fullWidth={isMobile}
            setQuantity={props.setQuantity}
            productName={props.productName}
            buyButtonText="Lägg i varukorg"
            getBuyButtonLabel={(name) => `Lägg i varukorg, ${name}`}
            theme="secondary"
        />
    );
};

export default ProductDetailsAddToCartButton;
